<template lang="pug">
  section.map-info(:class="'color_' + removeHashtag(projectInfo.color)" v-if="projectInfo" ref="component")
    article(v-show="projectInfo")
      .map-info-header(ref="header" :style="getBackgroundColorPropertyStyle(projectInfo.color)")
        i.project-number.ap-circle-double(:class="projectInfo.number > 9 ? 'gt9':''")
          span(:style="getColorPropertyStyle(projectInfo, true)") {{projectInfo.number}}
        h2(:class="getTitleClass(projectInfo.name)") {{projectInfo.name}}
        i.close.material-icons(@click="close($event)") clear
      .map-info-body(ref="body")
        v-tabs(v-model="activateTab" dark icons-and-text :color="projectInfo.color" slider-color="white")
          v-tab(href="#descripcion")
            div.tab-legend Descripción
            i.tab-icon.ap-description
          v-tab-item(value="descripcion" :lazy="true")
            figure.tab-content.tab_1(v-show="projectInfo")
              article
                ProjectImageSwiper.project-swiper(:project="projectInfo" @imageZoom="imageToZoom")
              br
              figcaption.slogan(:style="getColorPropertyStyle(projectInfo, true)" v-show="slogan") "{{slogan}}"
              figcaption(v-html="projectInfo.descripcion")
              br
              SharePanelWithProjectList(:projectInfo="projectInfo")
              .all-project-data
                span.asu-title Datos de todos los proyectos
                DownloadButton.download-glosario(:href="allProjectDataLink" type="link")
              .all-project-geojson
                span.asu-title Georeferencias de todos los proyectos
                DownloadButton.download-glosario(:href="allProjectGeojsonLink" type="link")
              div.responsables.source-data-text Los datos e información de los proyectos en esta plataforma son de responsabilidad de sus entes planificadores y/o ejecutores, AsuParticipa sólo promueve el acceso a la información sobre estos proyectos
          v-tab(href="#fichaTecnica")
            div.tab-legend Ficha Técnica
            i.tab-icon.ap-data-sheet
          v-tab-item(value="fichaTecnica" :lazy="true")
            .tab-content.tab_2(v-if="fichaTecnica")
              FichaTecnicaPanel(:fichaTecnica="fichaTecnica" :costo="projectInfo.costo" :color="projectInfo.color")
              div.responsables.source-data-text Los datos e información de los proyectos en esta plataforma son de responsabilidad de sus entes planificadores y/o ejecutores, AsuParticipa sólo promueve el acceso a la información sobre estos proyectos

          v-tab(href="#estadisticas")
            div.tab-legend Estadísticas
            i.tab-icon.ap-statistic
          v-tab-item(value="estadisticas" :lazy="true")
            .tab-content.tab_3
              StatisticPanel(:code="projectInfo.code" :color="projectInfo.color" :estadisticas="projectInfo.estadisticas")
              div.responsables.source-data-text Los datos e información de los proyectos en esta plataforma son de responsabilidad de sus entes planificadores y/o ejecutores, AsuParticipa sólo promueve el acceso a la información sobre estos proyectos

          v-tab(href="#documentos")
            div.tab-legend Documentos
            i.tab-icon.ap-download
          v-tab-item(value="documentos" :lazy="true")
            .tab-content.tab_4
              DownloadPanel(:code="projectInfo.code" :color="projectInfo.color" :documents="documents" baseUrl="/documents/projects/")
              div.responsables.source-data-text Los datos e información de los proyectos en esta plataforma son de responsabilidad de sus entes planificadores y/o ejecutores, AsuParticipa sólo promueve el acceso a la información sobre estos proyectos

          v-tab(href="#subproyectos" v-if="subprojects && subprojects.length")
            div.tab-legend Sub-proyectos
            i.tab-icon.ap-subproject
          v-tab-item(value="subproyectos" :lazy="true")
            .tab-content.tab_5
              SubprojectPanel(:subprojects="subprojects" :costo="projectInfo.costo" :color="projectInfo.color" :estadisticas="projectInfo.estadisticas" @subProjectOpenImgZoomDialog="imageToZoom")
              div.responsables.source-data-text Los datos e información de los proyectos en esta plataforma son de responsabilidad de sus entes planificadores y/o ejecutores, AsuParticipa sólo promueve el acceso a la información sobre estos proyectos

      ImageZoomDialog(:image="imageForDialog" @zoomImageDialogClosed="imageForDialog=null")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProjectService from '@/services/projects.js'
import mapInfoMixin from '@/mixins/map-info.js'

export default {
  name: 'MapInfo',
  mixins: [ mapInfoMixin ],
  components: {
    DownloadPanel: _ => import('@/components/DownloadPanel'),
    SharePanelWithProjectList: _ => import('@/components/participa/SharePanelWithProjectList'),
    ImageZoomDialog: _ => import('@/components/map/solucion-definitiva/panel/ImageZoomDialog'),
    ProjectImageSwiper: _ => import('@/components/map/solucion-definitiva/panel/ProjectImageSwiper'),
    FichaTecnicaPanel: _ => import('@/components/map/solucion-definitiva/panel/tab2/FichaTecnicaPanel'),
    StatisticPanel: _ => import('@/components/map/solucion-definitiva/panel/tab3/StatisticPanel'),
    SubprojectPanel: _ => import('@/components/map/solucion-definitiva/panel/tab5/SubprojectPanel')
  },
  props: {
    descriptionIndex: {
      default: 0,
      type: Number
    },
    projectInfo: Object
  },
  mounted () {
    if (this.$route.query.tab) {
      this.setActiveTab(this.$route.query.tab)
      this.activateTab = this.getActiveTab
    }
    this.subprojects = this.getSubprojects(this.projectInfo, this.filter)
    this.loadProyectInfo()
  },
  computed: {
    ...mapGetters({
      filter: 'projectsFilter',
      getActiveTab: 'getActiveTab'
    })
  },
  watch: {
    descriptionIndex (newValue, oldValue) {
      this.loadProjectComponent()
    },
    projectInfo (newValue, oldValue) {
      this.subprojects = this.getSubprojects(newValue, this.filter)
      this.loadProyectInfo()

      if (newValue && oldValue) {
        if (newValue.code !== oldValue.code) {
          this.setActivateTab('descripcion')
        }
      }
    },
    filter (newValue, oldValue) {
      this.subprojects = this.getSubprojects(this.projectInfo, newValue)
      this.loadProyectInfo()
    },
    imageForDialog (img) {
      this.imageForDialog = img
    },
    activateTab (val) {
      this.setActiveTab(val)
      this.activeTableAndUpdateRoute()
    },
    getActiveTab () {
      this.activateTab = this.getActiveTab
    }
  },
  data () {
    return {
      fichaTecnica: null,
      documents: null,
      slogan: null,
      subprojects: null,
      allProjectDataLink: 'https://drive.google.com/open?id=1_UH8DaXDPCZAtFEAHkBy3Qm7_IFzMeyr',
      allProjectGeojsonLink: 'https://drive.google.com/file/d/1h-79LlxWFfQDnAQU_HZQ6PlgicROCwgt/view?usp=sharing',
      imageForDialog: null,
      activateTab: null
    }
  },
  methods: {
    ...mapActions(['showProjectInfo', 'setActiveTab', 'setActivateTab', 'activeTableAndUpdateRoute']),
    close (event) {
      this.showProjectInfo(null)
      this.$emit('close', event)
      this.setActivateTab(undefined)
    },
    getSubprojects (project, filter) {
      return ProjectService.getSubprojects(project, filter)
    },
    imageToZoom (img) {
      this.imageForDialog = img
    },
    loadProyectInfo () {
      if (this.projectInfo) {
        this.loadProjectComponent()
        this.addRulesForTabIndicator()
      }
    },
    loadProjectComponent () {
      if (this.projectInfo) {
        this.loadFichaTecnica()
        this.slogan = this.projectInfo.slogan
        this.documents = ProjectService.loadAllDocuments(this.projectInfo)
        this.projectInfo.images = ProjectService.loadAllImages(this.projectInfo)
      }
    },
    loadFichaTecnica () {
      this.fichaTecnica = ProjectService.getFichaTecnica(this.projectInfo)
    },
    removeClass ($el, prefix) {
      const regex = new RegExp('^' + prefix, 'i')
      $el.classList.forEach(className => {
        if (regex.test(className)) {
          $el.className = $el.className.replace(className, '')
        }
      })
    }
  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/map/map-info-scoped'

.responsables
  padding: $f10px $f20px
  .tab_2 &, .tab_2 &
    margin-top: $f10px

figcaption
  s
    text-decoration: line-through
  u
    text-decoration: $gray solid underline

.all-project-data
  margin-top: $f20px

.all-project-data,
.all-project-geojson
  display: flex
  align-items: center
  justify-content: space-between
  padding: $f10px $f20px
  .asu-title
    margin: 0
    color: $color_0
    font-weight: bold

// Estilos para fijar cabezera
.map-info
  & >>>
    .v-tabs__container--fixed-tabs .v-tabs__div,
    .v-tabs__container--icons-and-text .v-tabs__div
      a
        padding: 0

</style>
<style lang="stylus">
.mapa .leaflet-sidebar
  & > .leaflet-control
    overflow: auto
    overflow: unset
  .close
    background-color: transparent
    color: white

.swiper-wrapper .image
  object-fit: contain

</style>
